import { FormItem, FormItemProps } from 'components/Form/FormItem';
import { Input } from 'components/Input/Input';
import { Col, Row, Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Commodity } from '@enmon/commons';
import { WaterMeterDetailField } from '../constants';
import { MeterDetails as messages } from '../../messages';
import { BinarySelect } from '../../../../Select/meter_details/Binary';
import { OrientationSelect } from '../../../../Select/meter_details/Orientation';
import { FlowrateSelect, FlowrateUnitSelect } from '../../../../Select/meter_details/Flowrate';
import { LayLengthSelect } from '../../../../Select/meter_details/LayLength';
import { DiameterNominalSelect } from '../../../../Select/meter_details/DiameterNominal';
import { TubeMaterialSelect } from '../../../../Select/meter_details/water/TubeMaterial';
import { WaterMeterMeasurementTypeSelect } from '../../../../Select/meter_details/water/WaterMeterMeasurementType';

export interface AdditionalWaterDetails {
  flowrateUnit?: string | null;
  flowrateValue?: number | null;
}

export const getWaterDetailFormItem = (
  field: WaterMeterDetailField,
  formItemProps: FormItemProps,
  { flowrateUnit, flowrateValue }: AdditionalWaterDetails,
) => {
  switch (field) {
    case WaterMeterDetailField.SecondSerialNumber:
      return (
        <FormItem
          label={<FormattedMessage {...messages.serialNumber2} />}
          name={['detail', 'secondSerialNumber']}
          tooltip={<FormattedMessage {...messages.serialNumber2Tooltip} />}
          {...formItemProps}
        >
          <Input placeholder="99op09899" />
        </FormItem>
      );
    case WaterMeterDetailField.HotWater:
      return (
        <FormItem
          label={<FormattedMessage {...messages.hotWater} />}
          name={['detail', 'hotWater']}
          tooltip={<FormattedMessage {...messages.hotWaterTooltip} />}
          {...formItemProps}
        >
          <BinarySelect name="hotWater" />
        </FormItem>
      );
    case WaterMeterDetailField.MeasurementType:
      return (
        <FormItem
          label={<FormattedMessage {...messages.measurementType} />}
          name={['detail', 'measurementType']}
          tooltip={<FormattedMessage {...messages.waterMeterMeasurementTypeTooltip} />}
          {...formItemProps}
        >
          <WaterMeterMeasurementTypeSelect />
        </FormItem>
      );
    case WaterMeterDetailField.Flange:
      return (
        <FormItem
          label={<FormattedMessage {...messages.flange} />}
          name={['detail', 'flange']}
          tooltip={<FormattedMessage {...messages.flangeTooltip} />}
          {...formItemProps}
        >
          <BinarySelect name="flange" />
        </FormItem>
      );
    case WaterMeterDetailField.Woltman:
      return (
        <FormItem
          label={<FormattedMessage {...messages.woltman} />}
          name={['detail', 'woltman']}
          tooltip={<FormattedMessage {...messages.woltmanTooltip} />}
          {...formItemProps}
        >
          <BinarySelect name="woltman" />
        </FormItem>
      );
    case WaterMeterDetailField.Orientation:
      return (
        <FormItem
          label={<FormattedMessage {...messages.orientation} />}
          name={['detail', 'orientation']}
          {...formItemProps}
        >
          <OrientationSelect />
        </FormItem>
      );
    case WaterMeterDetailField.Flowrate:
      return (
        <FormItem
          label={<FormattedMessage {...messages.flowRate} />}
          name={['detail', 'flowrate', 'value']}
          tooltip={<FormattedMessage {...messages.flowRateTooltip} />}
          {...formItemProps}
        >
          <Row className="w-100" style={{ display: 'inline-flex' }} wrap={false}>
            <Col span={7}>
              <Form.Item noStyle initialValue={flowrateUnit} name={['detail', 'flowrate', 'unit']}>
                <FlowrateUnitSelect commodity={Commodity.Water} />
              </Form.Item>
            </Col>
            <Col span={17}>
              <Form.Item noStyle initialValue={flowrateValue} name={['detail', 'flowrate', 'value']}>
                <FlowrateSelect unit={flowrateUnit} />
              </Form.Item>
            </Col>
          </Row>
        </FormItem>
      );
    case WaterMeterDetailField.LayLength:
      return (
        <FormItem
          label={<FormattedMessage {...messages.layLength} />}
          name={['detail', 'layLength']}
          tooltip={<FormattedMessage {...messages.layLengthTooltip} />}
          {...formItemProps}
        >
          <LayLengthSelect commodity={Commodity.Water} />
        </FormItem>
      );
    case WaterMeterDetailField.DiameterNominal:
      return (
        <FormItem
          label={<FormattedMessage {...messages.diameterDimensionNominal} />}
          name={['detail', 'diameterNominal']}
          tooltip={<FormattedMessage {...messages.diameterDimensionNominalTooltip} />}
          {...formItemProps}
        >
          <DiameterNominalSelect />
        </FormItem>
      );
    case WaterMeterDetailField.TubeMaterial:
      return (
        <FormItem
          label={<FormattedMessage {...messages.tubeMaterial} />}
          name={['detail', 'tubeMaterial']}
          {...formItemProps}
        >
          <TubeMaterialSelect />
        </FormItem>
      );
    default:
      return null;
  }
};
